export default __webpack_public_path__ + "static/media/hair-2-1.2eaf855d.svg";